import { EntityFilterRestriction } from "src/pages/EntityFiltersPage/EntityList/types";
import { ZUid } from "src/types/zUid";
import { ZBom3MatrixSettings } from "../../../ZBom3Settings";

/**
 * Строит filterRestrictions для модалки выбора Material по матрице ограничений BOM3.
 * Одна секция BOM -> одно значение Material type (enabled-ячейка в колонке sectionId).
 */
export const makeBom3MaterialFilterRestriction = (
  matrix: ZBom3MatrixSettings | null | undefined,
  sectionId: ZUid | undefined,
  materialTypeAttrId: ZUid | null | undefined,
): EntityFilterRestriction | undefined => {
  if (!sectionId || !matrix || !materialTypeAttrId) {
    return undefined;
  }
  const rowIdToName = new Map<ZUid, string>(
    matrix.rows.map(({ id, name }) => [id, name]),
  );
  const enabledForSection = matrix.cells.filter(
    ({ columnId, enabled }) => columnId === sectionId && enabled,
  );

  const [firstEnabled] = enabledForSection;
  if (!firstEnabled) {
    return undefined;
  }

  const filterValueStr = rowIdToName.get(firstEnabled.rowId);
  if (!filterValueStr) {
    return undefined;
  }

  return {
    filterAttrId: materialTypeAttrId,
    filterValueStr,
  };
};
